import { DeleteOutlined, EditOutlined, EyeFilled } from "@ant-design/icons";
import { Button } from "antd";
import Typography from "antd/es/typography/Typography";
import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { EditUseCaseViewRoute } from "..";
import {
  BackbuttonComponent,
  ColumnComponent,
  ContainerComponent,
  ImageWithFallback,
  RowComponent,
} from "../../../components";
import { useMutation, useQuery } from "../../../hooks";
import { Roles, useAuth } from "../../../providers";
import { DemoModal } from "../partials/demo-modal.partial";
import { ShowUseCaseContentPartial } from "../partials/show-use-case-content.partial";

export const ShowUseCaseView = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { useCaseId } = useParams();

  const [openResponsive, setOpenResponsive] = useState(false);

  const { data: useCase, loading } = useQuery({
    url: `/usecase/${useCaseId}`,
    options: { method: "GET" },
  });

  const { executeMutation: deleteWorkshop } = useMutation({
    url: `/usecase`,
    method: "DELETE",
    onSuccess: () => {
      navigate(-1);
    },
    onError: () => {
      alert("Error al eliminar el caso de uso");
    },
  });

  if (loading || !useCase) return <div>Loading...</div>;
  return (
    <>
      <BackbuttonComponent
        onClick={() => navigate("/catalog?filter=industries")}
        style={{
          marginBottom: 16,
          display: "block",
          textAlign: "left",
        }}
      />
      <ColumnComponent>
        <RowComponent style={{ justifyContent: "space-between", marginTop: 24 }}>
          <ContainerComponent style={{ width: "100%" }}>
            <Typography.Title level={2} style={{ alignSelf: "start" }}>
              {useCase.name}
            </Typography.Title>
          </ContainerComponent>

          <RowComponent style={{ justifyContent: "end", gap: 16 }}>
            {useCase?.demoUrl?.trim() && (
              <Button
                icon={<EyeFilled />}
                onClick={() => setOpenResponsive(true)}
              >
                Ver demostración
              </Button>
            )}
            {user?.role === Roles.ADMIN && (
              <Link to={EditUseCaseViewRoute({ useCaseId: useCase.id })}>
                <Button>
                  <EditOutlined /> Editar caso de uso
                </Button>
              </Link>
            )}
            {user?.role === Roles.ADMIN && (
              <Button
                style={{
                  backgroundColor: "#ee3a4c",
                  borderColor: "#ee3a4c",
                  color: "#ffffff",
                }}
                icon={<DeleteOutlined style={{ color: "#ffffff" }} />}
                onClick={() =>
                  deleteWorkshop({
                    id: useCase.id,
                  })
                }
              >
                Eliminar
              </Button>
            )}
          </RowComponent>
        </RowComponent>
        <ImageWithFallback
          src={useCase.imageUrl}
          alt={useCase.imgAlt}
          style={{ maxHeight: "250px", objectFit: "cover", borderRadius: "32px" }}
        />
        <ShowUseCaseContentPartial
          name={useCase.name}
          prompt={prompt}
          description={useCase.description}
          imageUrl={useCase.imageUrl}
          imgAlt={useCase.imgAlt}
          {...useCase}
        />
      </ColumnComponent>
      <DemoModal
        open={openResponsive}
        onClose={() => setOpenResponsive(false)}
        iframeUrl={useCase?.demoUrl}
      />
    </>
  );
};

export const ShowUseCaseRoute = ({ usecaseId }) => `/usecases/${usecaseId}`;
